export const characters = {
  'beleza-das-trevas': [
    {
      name: 'Azaan',
      slug: 'azaan',
      title: 'Grande General',
      age: 45,
      bio:
        'Grande General do Império de Zorel desde os 35 anos, sendo o mais novo Grande General até os dias de hoje.' +
        'Além das habilidades de luta incontestáveis tem uma inteligência além do comum, sendo um excelente ' +
        'estrategista. Peça principal do Império de Zorel atualmente.',
    },

    {
      name: 'Eve',
      slug: 'eve',
      title: 'Rainha das Succubus',
      age: '???',
      bio:
        'Primeira Succubus criada pelo Senhor do Submundo. Tem o poder de enfeitiçar qualquer ser, independente da raça ' +
        'ou gênero com sua beleza. É o único ser divino que conseguiu aceder ao Plano Material com todos portões selados, ' +
        'mas ninguém sabe como o fez.',
    },

    {
      name: 'Firyali',
      slug: 'firyali',
      title: 'Sombra Silenciosa',
      age: 25,
      bio:
        'Uma excelente ladra desde quando era criança, por ter crescido sem os pais. Ao tentar roubar uma espada sagrada ' +
        'guardada por Azaan foi capturada, mas pelas suas habilidades, Azaan ofereceu a chance dela se tornar uma espiã ' +
        'para o Império, sendo seu tutor pessoal em técnicas de combate. Ganhou o apelido de Sombra Silenciosa por suas ' +
        'habilidades como espiã.',
    },

    {
      name: 'Lyiot',
      slug: 'lyiot',
      title: 'Feiticeiro Demoníaco',
      age: 243,
      bio:
        'Antes um simples soldado do Império de Oop, Lyiot acede ao poder pelos poderes dados a ele por Eve e se torna o ' +
        'feiticeiro mais poderoso conhecido, combinando com suas técnicas de combate que também foram aperfeiçoadas, é um ' +
        'dos seres mais temidos do Plano Material.',
    },
  ],

  'era-sombria': [
    {
      name: 'Bellatrix',
      slug: 'bellatrix',
      title: 'Pirata Lendária',
      age: 35,
      bio:
        'Antiga marinha de Naohr, o Monte Perdido. Resolveu largar as tropas por sentir seu talento desperdiçado.' +
        'Antes de completar 30 anos, já era considerada a maior pirata que já existiu. Procurada por todas as nações, ' +
        'nenhum exército foi capaz de capturar ela ou qualquer um dos integrantes do seu bando.',
    },

    {
      name: 'Kyr',
      slug: 'kyr',
      title: 'O Capitão Rebelde',
      age: 28,
      bio:
        'Excelente marinheiro e que sabe manejar uma espada muito bem desde criança. Se tornou capitão de um grupo do ' +
        'exército de Jaal muito novo, mas também foi o capitão mais rápido de ser expulso do exército. Isso lhe rendeu o ' +
        'apelido de "Capitão Rebelde". Possui habilidades de combate excepcionais e se tornou o braço direito de Bellatrix ' +
        'pela sua perícia em combate e por fazer parte de um seleto grupo de pessoas que conseguem manipular a magia.',
    },

    {
      name: 'Lynx',
      slug: 'lynx',
      title: 'A Morte Vermelha',
      age: '???',
      bio:
        'Um ser misterioso que apareceu para Zyon depois que ele destruiu Jaal e criou sua fortaleza na ilha Bocco. Lynx ' +
        'sabe manipular diversos tipos de magia e possui uma foice gigante que maneja com grande facilidade e agilidade. ' +
        'Não parece possuir nenhum tipo de emoção ou sentimento, matando qualquer um sem remorso algum. Depois de eliminar ' +
        'três tropas sozinho quando tentaram invadir Bocco, ficou conhecido como "A Morte Vermelha".',
    },

    {
      name: 'Zyon',
      slug: 'zyon',
      title: 'O Imperador Infernal',
      age: 42,
      bio:
        'Um pirata solitário que passou grande parte da vida estudando a magia e pesquisando sobre uma lenda que leu em ' +
        'um livro quando criança, a "Espada do Vazio". Uma arma forjada em outro universo e enviada por engano para esse mundo. ' +
        'Depois de muitos anos tentando encontrar a espada, finalmente conseguiu, apenas para ter sua alma corrompida, se tornando ' +
        'um semi-demônio com poderes infernais.',
    },
  ],

  'maldicao-eterna': [
    {
      name: 'Giganto #1',
      slug: 'giganto',
      title: 'Golem Protetor',
      age: 20,
      bio:
        'Criatura criada de rochas na fortaleza de Sorin por Liz através da Magia Anciã. Atende todas as ordens de Liz, ' +
        'estando sempre ao seu lado. O único ser capaz de comandar ele, sobrepondo até mesmo as ordens dadas por Liz é ' +
        'é Sorin.',
    },

    {
      name: 'Liz',
      slug: 'liz',
      title: 'General Escarlate',
      age: 330,
      bio:
        'Principal general dos exércitos do Império da Folha da Vida. Sempre teve grande facilidade na manipulação de magia. ' +
        'Pelo seu visual, recebeu o nome de General Escarlate. Ao se encontrar com Sorin, teve facilidade em aprender o que ' +
        'ele a ensinava e por isso ele a ensinou a manipular a Magia Anciã, a qual teve certa facilidade em manipular. Sorin ' +
        'se viu fascinado pelas suas habilidades, lhe dando o cargo de General de todo seu exército.',
    },

    {
      name: 'Serlyon',
      slug: 'serlyon',
      title: 'Vento Dourado',
      age: 300,
      bio:
        'Irmão mais novo de Liz, sempre a viu como um modelo por causa de suas habilidades e sua postura firme, apesar do ' +
        'seu jeito meigo de ser. Serlyon se mostrou extremamente habilidoso com o uso de espadas desde pequeno. Pela sua ' +
        'agilidade e leveza nos movimentos em combate, Serlyon recebeu o nome de Vento Dourado. Após a traição de Liz, passou ' +
        'a ser o responsável pelos exércitos do Império da Folha da Vida.',
    },

    {
      name: 'Sorin',
      slug: 'sorin',
      title: 'O Imortal',
      age: '+- 1200',
      bio:
        'O ser mais antigo desse mundo e também o mais poderoso, após conseguir dominar suas habilidades adquiridas pela ' +
        'maldição que seu pai o lançou, resolveu criar um Império e moldar o mundo segundo sua vontade. Se viu apaixonado ' +
        'por Liz e sendo correspondido, ambos planejam dominar todos os impérios do mundo para eles. Sorin bebe o sangue de ' +
        'Liz diariamente, que o cede voluntariamente. Sorin busca uma forma de tornar sua amada em um ser imortal como ele.',
    },
  ],

  'samurais-seculo-xxi': [
    {
      name: 'Ann',
      slug: 'ann',
      title: 'Empresária',
      age: 25,
      bio:
        'Uma empresária famosa, que começou seu negócio aos 17 anos. Seu pai lhe ensinou desde cedo a lutar com nunchakus ' +
        'e ela se interessou bastante, treinando diariamente desde os 12 anos. Pelas suas habilidades, decidiu entrar em uma ' +
        'organização de guerreiros que se intitulavam como os Samurais do Século XXI.',
    },

    {
      name: 'Ban',
      slug: 'ban',
      title: 'Detetive',
      age: 28,
      bio:
        'Detetive particular que aprendeu desde cedo como manusear uma espada e um estilo de combate que nunca tinha visto ' +
        'antes. Muito habilidoso em combate com espada e com movimentos rápidos, possui grande interesse em descobrir pessoas ' +
        'como ele. Usa sua profissão para investigar e encontrar pessoas com habilidades de luta incomuns e atualmente persegue ' +
        'uma organização de guerreiros com essas habilidades.',
    },

    {
      name: 'Shikijo',
      slug: 'shikijo',
      title: 'Advogado',
      age: 35,
      bio:
        'Advogado que sempre treinou muito seu corpo, puxando aos limites e aperfeiçoando sua resistência. Estilo de combate ' +
        'ensinado pelo seu pai. Possui um senso de justiça muito grande e gosta de proteger as pessoas fracas e desamparadas. ' +
        'Persegue uma organização de guerreiros com habilidades incomuns como a sua, que ele descobriu que foi a responsável ' +
        'pela morte de seu pai.',
    },

    {
      name: 'Slash',
      slug: 'slash',
      title: 'Cantor',
      age: 29,
      bio:
        'É um cantor que ama se mostrar e se exaltar. Possui uma paixão exagerada por si mesmo e acha que é o melhor ' +
        'em tudo que faz. Possui uma carreira local fracassada, mas que sempre faz parecer que está fazendo muito sucesso. ' +
        'Aprendeu a lutar com uma espada de lâmina dupla com seu tio e foi procurado por Ann para se juntar ao grupo chamado ' +
        'Samurais do Século XXI.',
    },
  ],
}

export const universes = [
  {
    name: 'A Beleza das Trevas',
    slug: 'beleza-das-trevas',
    characters: characters['beleza-das-trevas'],
  },
  {
    name: 'Era Sombria',
    slug: 'era-sombria',
    characters: characters['era-sombria'],
  },
  {
    name: 'A Maldição Eterna',
    slug: 'maldicao-eterna',
    characters: characters['maldicao-eterna'],
  },
  {
    name: 'Samurais do Século XXI',
    slug: 'samurais-seculo-xxi',
    characters: characters['samurais-seculo-xxi'],
  },
]

export const tournaments = [
  {
    name: 'Torneio Universo A Beleza das Trevas',
    url:
      'https://www.youtube.com/playlist?list=PL-IrmVyXOTXwB-GN_u9yshuyQgsDkyAzU',
  },

  {
    name: 'Torneio Universo Era Sombria',
    url:
      'https://www.youtube.com/playlist?list=PL-IrmVyXOTXwO2vVh1G5LCQEwprkRNMfX',
  },

  {
    name: 'Torneio Universo A Maldição Eterna',
    url:
      'https://www.youtube.com/playlist?list=PL-IrmVyXOTXwMzNn_X_p1MfnL5r66IyNA',
  },
]

export default { universes, characters, tournaments }
